import { HomePageData } from '@/types/homePage';
import { FacebookIcon, TwitterIcon, LinkedinIcon, PinIcon } from 'lucide-react';

// Main home page data
export const homePageData: HomePageData = {
  hero: {
    tagline: "INNOVATIVE FEATURES & SUPPORT",
    heading: "Empowering Businesses.\nInspiring Progress.",
    description: "Tailor-made digital solutions to boost performance, security, and growth for your business.",
    ctaButton: {
      text: "Discover Our IT Services",
      href: "#about",
    },
    images: {
      background: {
        src: "/svg/triangles-hero-container.svg",
        alt: "Triangular shapes background",
      },
      main: {
        src: "/svg/right-section-hero.svg",
        alt: "Developer coding on laptop with modern interface",
      },
    },
  },
  about: {
    tagline: "KNOW ABOUT US",
    heading: "Stay Ahead the Curve with IT Solution",
    description: "At CISCODE, we help organizations embrace the future of technology. With a proven track record in finance, insurance, healthcare, logistics, and industry, we design secure and scalable solutions tailored to your needs. Our team of experts brings agility, reliability, and innovation to every project, ensuring long-term success for our clients.",
    bulletPoints: [
      "International expertise and proven methodologies",
      "Custom IT solutions adapted to your business challenges",
      "A trusted partner in digital transformation",
    ],
    ctaButton: {
      text: "Learn More About CISCODE",
      href: "#about",
    },
    images: {
      main: {
        src: "/svg/left-section-aboutus.svg",
        alt: "IT professionals working on modern technology solutions",
      },
      background: {
        src: "/svg/absolute-element-aboutus.svg",
        alt: "Background decoration",
      },
    },
  },
  creativeTeam: {
    tagline: "CREATIVE TEAM",
    heading: "Innovative Solutions for a Fast Paced",
    teamMembers: [
      {
        id: "albert-flores",
        name: "",
        role: "",
        image: {
          src: "https://placehold.co/600x400?text=SOON",
          alt: "Albert Flores - Boys Trainer",
        },
        socialLinks: {
          facebook: "#s",
          twitter: "#",
          linkedin: "#",
          instagram: "#",
        },
      },
      {
        id: "courtney-henry-designer",
        name: "",
        role: "",
        image: {
          src: "https://placehold.co/600x400?text=SOON",
          alt: "Courtney Henry - Web Designer",
        },
        socialLinks: {
          facebook: "#",
          twitter: "#",
          linkedin: "#",
          instagram: "#",
        },
      },
      {
        id: "courtney-henry-it",
        name: "",
        role: "",
        image: {
          src: "https://placehold.co/600x400?text=SOON",
          alt: "Courtney Henry - IT Expert",
        },
        socialLinks: {
          facebook: "#",
          twitter: "#",
          linkedin: "#",
          instagram: "#",
        },
      },
      {
        id: "john-doe",
        name: "",
        role: "",
        image: {
          src: "https://placehold.co/600x400?text=SOON",
          alt: "John Doe - Frontend Developer",
        },
        socialLinks: {
          facebook: "#",
          twitter: "#",
          linkedin: "#",
          instagram: "#",
        },
      },
      {
        id: "jane-smith",
        name: "",
        role: "",
        image: {
          src: "https://placehold.co/600x400?text=SOON",
          alt: "Jane Smith - UI/UX Designer",
        },
        socialLinks: {
          facebook: "#",
          twitter: "#",
          linkedin: "#",
          instagram: "#",
        },
      },
      {
        id: "mike-wilson",
        name: "Mike Wilson",
        role: "Backend Developer",
        image: {
          src: "https://placehold.co/600x400?text=SOON",
          alt: "Mike Wilson - Backend Developer",
        },
        socialLinks: {
          facebook: "#",
          twitter: "#",
          linkedin: "#",
          instagram: "#",
        },
      },
      {
        id: "sarah-johnson",
        name: "Sarah Johnson",
        role: "Project Manager",
        image: {
          src: "https://placehold.co/600x400?text=SOON",
          alt: "Sarah Johnson - Project Manager",
        },
        socialLinks: {
          facebook: "#",
          twitter: "#",
          linkedin: "#",
          instagram: "#",
        },
      },
      {
        id: "alex-martinez",
        name: "",
        role: "",
        image: {
          src: "https://placehold.co/600x400?text=SOON",
          alt: "Alex Martinez - DevOps Engineer",
        },
        socialLinks: {
          facebook: "#",
          twitter: "#",
          linkedin: "#",
          instagram: "#",
        },
      },
      {
        id: "mounni-zaid",
        name: "",
        role: "",
        image: {
          src: "https://placehold.co/600x400?text=SOON",
          alt: "Alex Martinez - DevOps Engineer",
        },
        socialLinks: {
          facebook: "#",
          twitter: "#",
          linkedin: "#",
          instagram: "#",
        },
      },
    ],
  },
  topBar: {
    socialLinks: {
      facebook: "#",
      twitter: "#",
      linkedin: "#",
      instagram: "#",
    },
    contactInfo: {
      phone: "+1 (555) 123-4567",
      email: "contact@ciscode.co.uk",
    },
  },
  gallery: {
    tagline: "OUR GALLERY",
    heading: "Revolutionizing Technology for a Brighter Future",
    items: [
      {
        id: 1,
        image: "/images/gallery-section/018241dbe0402d0e115ba35d62bdee2be3f59f77.jpg",
        alt: "Modern technology and innovation showcase",
        title: "IT Services"
      },
      {
        id: 2,
        image: "/images/gallery-section/1488a3b4c6e0413fe680b9d88def12f11948d25e.jpg", 
        alt: "Advanced digital solutions and development",
        title: "IT Services"
      },
      {
        id: 3,
        image: "/images/gallery-section/2e628f8e7fd94d9a360f058ea94a68f8211bb03a.png",
        alt: "Cutting-edge technology implementation",
        title: "IT Services"
      },
      {
        id: 4,
        image: "/images/gallery-section/8f1b6cccbff39b67e398e5355ef9d2f2b31b6c5e.png",
        alt: "Professional IT consulting and support",
        title: "IT Services"
      },
      {
        id: 5,
        image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80",
        alt: "Manufacturing and industrial automation solutions",
        title: "IT Services"
      }
    ]
  },
  contactUs: {
    tagline: "CONTACT US",
    heading: "Driving Efficiency IT through Innovation",
    submitButton: {
      text: "Send Now",
    },
  },
  footer: {
    companyInfo: {
      logo: {
        src: "/svg/logo.svg",
        alt: "CISCODE Logo",
      },
      description: "Lorem ipsu dolor amet, consectetur sell adipis elit phase nibh ellentes",
    },
    socialLinks: [
      { icon: LinkedinIcon, href: "https://www.linkedin.com/company/ciscode" },
      { icon: PinIcon, href: "#" },
    ],
    usefulLinks: {
      title: "Useful Links",
      links: [
        { text: "About Us", href: "#about" },
        { text: "Our Team", href: "#team" },
        { text: "Recent News", href: "#news" },
        { text: "Projects", href: "#projects" },
      ],
    },
    contact: {
      title: "Contact",
      email: "contact@ciscode.co.uk",
      address: "182-184 High Street North East Ham, London E6 2JA, United Kingdom",
    },
    subscribe: {
      title: "Subscribe",
      description: "Lorem Ipsum is simp the a dumiomy is text Lorem Ipsum is simply",
    },
    copyright: "© CISCODE 2025 | All Rights Reserved",
    footerLinks: [
      { text: "Terms & Conditions", href: "#terms" },
      { text: "Privacy Policy", href: "#privacy" },
      { text: "Contact Us", href: "#contact" },
    ],
  },
  navBar: {
    logo: {
      src: "https://c.animaapp.com/mflo2450ETV2bb/img/image-8.png",
      alt: "Company Logo",
    },
    navigationItems: [], // Will be populated from existing navigationData
  },
  latestService: {
    tagline: "LATEST SERVICE",
    heading: "Empower Your Business with IT Excellence",
    services: [
      {
        id: "it-consultation",
        title: "IT Consultation",
        description: "Strategic guidance to drive digital success",
        icon: "/svg/latest-service/it_consultation.svg"
      },
      {
        id: "web-mobile-development",
        title: "Web & Mobile Development",
        description: "Custom solutions designed for growth and security",
        icon: "/svg/latest-service/web&mobile_dev.svg"
      },
      {
        id: "cloud-devops",
        title: "Cloud & DevOps Solutions",
        description: "Optimize performance with secure cloud automation",
        icon: "/svg/latest-service/cloud&devops.svg"
      },
      {
        id: "maintenance-support",
        title: "Maintenance & IT Support",
        description: "Safeguard operations with 24/7 protection and care",
        icon: "/svg/latest-service/it_support.svg"
      }
    ]
  },
  askQuestion: {
    tagline: "ASK QUESTION",
    heading: "Revolutionizing For\nTechnology Future",
    faqItems: [
      {
        id: "item-1",
        question: "What makes CISCODE different from others?",
        answer: "CISCODE combines technical expertise with deep industry knowledge, having worked in banking, finance, pharmaceuticals, healthcare, and industry. Our tailored approach ensures innovation with measurable business impact."
      },
      {
        id: "item-2",
        question: "How can CISCODE accelerate our digital transformation?",
        answer: "We provide comprehensive digital transformation services including cloud migration, process automation, data analytics, and modern application development. Our proven methodologies ensure faster time-to-market and reduced implementation risks."
      },
      {
        id: "item-3",
        question: "Do you provide end-to-end solutions?",
        answer: "Yes, CISCODE offers complete end-to-end solutions from initial consultation and strategy development to implementation, maintenance, and ongoing support. We handle every aspect of your IT needs."
      },
      {
        id: "item-4",
        question: "How does CISCODE ensure security and compliance?",
        answer: "We implement industry-standard security protocols, conduct regular security audits, and ensure compliance with relevant regulations. Our team is certified in various security frameworks and follows best practices for data protection."
      },
      {
        id: "item-5",
        question: "How does CISCODE ensure long-term value for its clients?",
        answer: "We focus on building scalable, maintainable solutions that grow with your business. Our ongoing support, regular updates, and strategic guidance ensure your technology investments continue to deliver value over time."
      }
    ]
  },
  brandsSlider: {
    brands: [
      {
        text: "DataMasters",
        isOutlined: false,
        hasIcon: true,
      },
      {
        text: "DigitalSolutions",
        isOutlined: true,
        hasIcon: true,
      },
      {
        text: "TechInnovators",
        isOutlined: false,
        hasIcon: true,
      },
      {
        text: "Revolutionizing Tech",
        isOutlined: true,
        hasIcon: false,
      },
      {
        text: "CloudMasters",
        isOutlined: false,
        hasIcon: true,
      },
      {
        text: "AI Solutions",
        isOutlined: true,
        hasIcon: true,
      },
      {
        text: "FutureTech",
        isOutlined: false,
        hasIcon: false,
      },
      {
        text: "DigitalTransformation",
        isOutlined: true,
        hasIcon: true,
      }
    ]
  },
  clientsReviews: {
    tagline: "CLIENTS REVIEWS",
    heading: "Simplify Streamline Succeed IT",
    reviews: [
      {
        id: "review-1",
        name: "Alex Simmons",
        title: "President of Sales",
        rating: 3.5,
        review: "There are many variations of passages Lorem Ipsum available, but the majority have suffered alteration in some form. There are many variations Lorem ipsum is most of the passages of Lorem ipsum is most valuable."
      },
      {
        id: "review-2",
        name: "Sarah Johnson",
        title: "CEO, TechCorp",
        rating: 5.0,
        review: "CISCODE transformed our entire IT infrastructure with exceptional expertise. Their team delivered beyond our expectations, providing innovative solutions that streamlined our operations and boosted productivity significantly."
      },
      {
        id: "review-3",
        name: "Michael Chen",
        title: "CTO, InnovateLab",
        rating: 4.8,
        review: "The digital transformation services provided by CISCODE were outstanding. They understood our complex requirements and delivered a scalable solution that has positioned us for future growth. Highly recommended!"
      },
      {
        id: "review-4",
        name: "Emily Rodriguez",
        title: "Operations Director",
        rating: 4.7,
        review: "Working with CISCODE has been a game-changer for our business. Their cloud migration services were seamless, and their ongoing support ensures our systems run smoothly. Professional and reliable team."
      },
      {
        id: "review-5",
        name: "David Thompson",
        title: "IT Manager",
        rating: 4.9,
        review: "CISCODE's cybersecurity solutions gave us peace of mind. Their comprehensive approach to protecting our data and systems is impressive. The team is knowledgeable, responsive, and always available when needed."
      }
    ]
  },
  numberTalks: {
    tagline: "NUMBER TALKS",
    heading: "Coding Future\nHome Today",
    stats: [
      {
        id: "team-members",
        icon: "/svg/number-talks/team_member.svg",
        number: "200+",
        label: "Team member"
      },
      {
        id: "projects",
        icon: "/svg/number-talks/complete_project.svg",
        number: "10k+",
        label: "Complete project"
      },
      {
        id: "reviews",
        icon: "/svg/number-talks/client_review.svg",
        number: "900+",
        label: "Client review"
      }
    ]
  },
  workProcess: {
    tagline: "WORK PROCESS",
    heading: "Guided by Values. Driven by Excellence.",
    steps: [
      {
        id: "understanding-vision",
        number: "01",
        title: "Understanding Your Vision",
        icon: "/svg/work-process/icon1.svg",
        bgColor: "bg-[#111536]",
      },
      {
        id: "designing-integrity",
        number: "02",
        title: "Designing with Integrity",
        icon: "/svg/work-process/icon2.svg",
        bgColor: "bg-[#111536]",
      },
      {
        id: "delivering-excellence",
        number: "03",
        title: "Delivering with Excellence",
        icon: "/svg/work-process/icon3.svg",
        bgColor: "bg-x-700",
      },
      {
        id: "building-partnerships",
        number: "04",
        title: "Building Partnerships",
        icon: "/svg/work-process/icon4.svg",
        bgColor: "bg-x-700",
      },
    ],
  },
  blog: {
    tagline: "OUR LATEST BLOGS",
    heading: "Simplify IT for Enhanced the a Productivity",
    blogPosts: [
      {
        id: "blog-1",
        title: "Innovate Create Inspire your brand to life in",
        category: "Technology",
        author: "Admin",
        date: { day: "16", month: "Mar" },
        readMoreStyle: "text-x-900",
        arrowStyle: "text-x-900",
      },
      {
        id: "blog-2", 
        title: "Experience Innovation with Leading-Edge",
        category: "Technology",
        author: "Admin",
        date: { day: "16", month: "Mar" },
        readMoreStyle: "text-x-900",
        arrowStyle: "text-x-900",
      },
      {
        id: "blog-3",
        title: "Elevate Your Business with Intelligent IT",
        category: "Technology", 
        author: "Admin",
        date: { day: "16", month: "Mar" },
        readMoreStyle: "text-x-900",
        arrowStyle: "text-x-900",
      },
    ],
  },
  digitalSolutions: {
    serviceCards: [
      {
        id: "web-development",
        image: "https://c.animaapp.com/mflo2450ETV2bb/img/image-1.png"
      },
      {
        id: "strategy-planning",
        image: "https://c.animaapp.com/mflo2450ETV2bb/img/image-2.png"
      },
      {
        id: "it-outsourcing",
        image: "https://c.animaapp.com/mflo2450ETV2bb/img/image-3.png"
      }
    ]
  },
};

// For future multilingual support:
// export const homePageDataEn: HomePageData = { ... };
// export const homePageDataFr: HomePageData = { ... };
// export const homePageDataAr: HomePageData = { ... };
